import { ArrowDown } from "lucide-react";
import { ScrollReveal } from "./Reveal";
import { scrollToId } from "./Navbar";

const PARAGRAPHS = [
  "Bună ziua! Numele meu este Maria Romașcu și am crescut în sistemul educațional japonez, de la grădiniță până în clasa a IX-a. Toate cursurile se țineau în limba japoneză, iar profesorii erau japonezi. Am început să învăț limba japoneză la vârsta de cinci ani, iar o mare parte din copilăria mea a fost influențată de cultura și limba japoneză.",
  "La școală nu am învățat doar limba, ci și un mod de a trăi. Am participat la evenimente tradiționale precum Akimatsuri (festivalul de toamnă), Undōkai (ziua sportului) și Gakushū Happyōkai (prezentările anuale ale elevilor). La orele de Kateika am învățat să gătesc, să cos și să am grijă de spațiul în care trăiesc. Înainte de vacanțele de vară și de iarnă, întreaga școală făcea curățenie împreună, iar asta m-a învățat responsabilitatea și respectul față de comunitate. Profesorii mei japonezi au avut mereu răbdare cu mine și m-au încurajat, iar sprijinul lor m-a ajutat să capăt încredere în mine.",
  "Această experiență mi-a adus numeroase beneficii, atât în plan profesional, cât și personal. Am învățat disciplina, ambiția și curajul. Prin urmare, Japonia și limba japoneză nu reprezintă doar o calitate a mea, ci fac parte din mine și din cine sunt. Japoneza mi-a oferit un alt mod de a gândi și de a privi lumea.",
  "Astăzi doresc să împărtășesc tot ceea ce am învățat în sistemul educațional japonez cu copiii din generația actuală, dar și cu adulții. Consider că fiecare copil merită încurajare și răbdare, la fel cum le-am primit și eu. Prin urmare, misiunea mea este să transmit mai departe aceste valori, oferind fiecărui elev un mediu de învățare bazat pe respect, sprijin și dorința de a evolua.",
];

const BADGES = [
  "10 ani de experiență în sistemul educațional japonez",
  "4 ani de experiență în predat",
  "Toate nivelurile · Toate vârstele",
];

export default function Profesoara() {
  return (
    <section id="profesoara" data-testid="profesoara-section" className="relative pt-20 sm:pt-32 pb-10 sm:pb-14 overflow-hidden">
      <span aria-hidden className="pointer-events-none select-none absolute right-2 top-24 vertical-rl font-jp text-7xl text-sumi/[0.05] hidden sm:block">
        先生の物語
      </span>

      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <ScrollReveal>
              <p className="text-xs font-mono tracking-[0.3em] uppercase text-hanko mb-4">Despre Profesoară</p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-sumi leading-tight">
                Experiență <span className="italic text-hanko">reală</span> în sistemul de educație japonez.
              </h2>
            </ScrollReveal>
            <ScrollReveal delay={0.2} className="mt-10">
              <div className="relative aspect-[4/5] max-w-sm group">
                <img
                  src="/profesoara-maria.webp"
                  alt="Maria Romașcu, fondatoarea și profesoara SORA"
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                  data-testid="profesoara-image"
                />
                <div className="absolute inset-0 ring-1 ring-sumi/10 pointer-events-none" />
                <img
                  src="/sora-logo.png"
                  alt="Sigiliul SORA"
                  className="absolute bottom-3 right-3 h-11 w-auto drop-shadow-[0_6px_16px_rgba(0,0,0,0.35)]"
                  data-testid="profesoara-image-logo"
                />
              </div>
              <p className="mt-5 font-mono text-xs tracking-[0.25em] uppercase text-charcoal/55" data-testid="profesoara-name">
                Maria Romașcu · fondatoare & profesoară
              </p>
              <div className="mt-4 flex flex-wrap gap-2" data-testid="profesoara-badges">
                {BADGES.map((b) => (
                  <span
                    key={b}
                    data-testid={`profesoara-badge-${BADGES.indexOf(b) + 1}`}
                    className="border border-hanko/40 bg-hanko/[0.06] text-hanko rounded-full px-3.5 py-1.5 text-[11px] font-mono tracking-wide"
                  >
                    {b}
                  </span>
                ))}
              </div>
            </ScrollReveal>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-6 lg:pt-24">
              {PARAGRAPHS.map((p, i) => (
                <ScrollReveal key={i} delay={i * 0.08}>
                  <p
                    data-testid={`profesoara-paragraph-${i + 1}`}
                    className="text-charcoal/80 leading-relaxed text-sm sm:text-base border-l-2 border-hanko/30 pl-5"
                  >
                    {p}
                  </p>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>

        <ScrollReveal delay={0.1} className="mt-12 text-center">
          <button
            data-testid="profesoara-cta-trial-button"
            onClick={() => scrollToId("#lectie")}
            className="group bg-hanko text-washi font-semibold px-8 py-4 rounded-full text-base hover:bg-hankodeep transition-colors duration-300 inline-flex items-center gap-2"
          >
            Programează o lecție gratuită
            <ArrowDown size={18} className="transition-transform duration-300 group-hover:translate-y-1" />
          </button>
        </ScrollReveal>
      </div>
    </section>
  );
}
